









import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component
export default class TooltipIconButton extends Vue {
  @Prop({default: 'primary'}) private readonly type: string;
  @Prop({default: 'small'}) private readonly size: string;
  @Prop({default: ''}) private readonly icon: string;
  @Prop({default: false}) private readonly circle: boolean;
  @Prop({default: false}) private readonly disabled: boolean;
  @Prop({default: false}) private readonly loading: boolean;
  @Prop({default: ''}) private readonly label: string;
  @Prop({default: 'left'}) private readonly labelPosition: string;
  @Prop({default: ''}) private tooltipContent: string;
  @Prop({default: 'tooltip-item-class'}) private tooltipClass: string;

  private innerLoading: boolean = false;

  get isLoading() {
    return this.loading || this.innerLoading;
  }

  get buttonType() {
    return this.type;
  }

  get getSize() {
    return this.size;
  }

  get iconClass() {
    return this.isLoading ? 'el-icon-loading' : this.icon;
  }

  get isCircle() {
    return this.circle;
  }

  get isDisabled() {
    return this.disabled;
  }

  get buttonLabel() {
    return this.label;
  }

  get getTooltipClass() {
    return this.tooltipClass;
  }

  get getHtml() {
    if (this.labelPosition === 'right') {
      return `<span><i class="${this.iconClass}"></i>${this.buttonLabel}</span>`;
    } else {
      // <i /> 형태로 내보내면 라벨이 i 태그 안으로 들어가는 버그 생김
      return `<span>${this.buttonLabel}<i class="${this.iconClass}" /></span>`;
    }
  }

  get getTooltipContent() {
    return this.tooltipContent;
  }

  public switchOn() {
    this.innerLoading = true;
  }

  public switchOff() {
    this.innerLoading = false;
  }

  public onClick($event: any) {
    if (this.isLoading) {
      return;
    }
    this.$emit('click', $event);
    this.$emit('switch', {
      $event,
      on: this.switchOn,
      off: this.switchOff
    });
  }
}
